import { atomWithReset } from "jotai/utils";

export const componentStatus = {
  load: {
    isEditing: true,
    completed: false,
  },
  genset: {
    isEditing: false,
    completed: false,
  },
  pv: {
    isEditing: false,
    completed: false,
  },
  battery: {
    isEditing: false,
    completed: false,
  },
  grid: {
    isEditing: false,
    completed: false,
  },
  controller: {
    isEditing: false,
    completed: false,
  },
  evcs: {
    isEditing: false,
    completed: false,
  },
};

export const componentStatusAtom = atomWithReset(componentStatus);
